import React, { useRef } from 'react';
import { useInView, useReducedMotion } from 'framer-motion';

export const HeroScene = ({ src, testId, children, className = '', contain = false, alt = '' }) => {
    const ref = useRef(null);
    const visible = useInView(ref, { amount: 0.3 });
    const seen = useInView(ref, { amount: 0.3, once: true });
    const reduced = useReducedMotion();
    return (
        <div ref={ref} className={`sp-hero-scene ${className}`} data-testid={testId} data-seen={seen && !reduced} data-visible={visible}>
            <img src={src} alt={alt} aria-hidden={alt ? undefined : true} data-testid={`${testId}-image`} width="1200" height="805" loading="lazy" draggable="false" className={`sp-scene-art ${contain ? 'sp-scene-art-contain' : ''}`} />
            <span aria-hidden="true" className="sp-scene-shine" />
            {children}
        </div>
    );
};
